export default __webpack_public_path__ + "static/media/paymentpng.80e2211d.png";